import { render } from "./AddressValidator.vue?vue&type=template&id=5468340d"
import script from "./AddressValidator.vue?vue&type=script&lang=js"
export * from "./AddressValidator.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__